export enum CloudRoute {
  Callback = 'callback',
  SocialDemoCallback = 'social-demo-callback',
}
